// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"MobileAcceptProposalModal_modal_body__394_z","footer":"MobileAcceptProposalModal_footer__1AzXX"};